export class TinyMCE {
    height = 220;
    menubar = false;
    plugins = [];
}
